import { render, staticRenderFns } from "./associationForm.vue?vue&type=template&id=1d4a894b&scoped=true&"
import script from "./associationForm.vue?vue&type=script&lang=js&"
export * from "./associationForm.vue?vue&type=script&lang=js&"
import style0 from "./associationForm.vue?vue&type=style&index=0&id=1d4a894b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4a894b",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QTabs,QTab,QInput,QIcon,QSelect,QBtn,QImg,QToggle,QTd,QTooltip});
